export const DEFAULT_ENVIRONMENT_IMPACT = 'Infinity Restore';
export const PRODUCTION_ENVIRONMENT_IMPACT = 'Production';
export const ADD_UNDERWRITER_ENVIRONMENT_IMPACT = 'PaymentPortal Restore';
export const DEFAULT_PARAMETER_ROW_ID = '1';
export const EXECUTION_DELAY_MS = 1500;
export const PREVIEW_FETCH_DELAY_MS = 500;
export const REQUESTER_EMAIL_AUTOPOPULATE_DELAY_MS = 500;
export const INCIDENT_ID_INVALID_CHARS = /[!@#$%^&*()_+=.,]/;
export const SUBCOMPANY_CODE_VALID = /^[a-zA-Z0-9]+$/;
export const MESSAGES = {
 requiredFields: 'Please fill in all required fields in all parameter rows.',
 incorrectIncidentId: 'Incorrect Incident Id',
 invalidSubcompany: 'Subcompany is not valid',
 executionFailed: 'Database connection timeout. Please try again.',
 genericExecutionFailed: 'Script execution failed',
 requesterEmailPrefix: 'requester_',
 requesterEmailDomain: '@tokiomarine.com',
 executionStatusUpdated: 'Updated',
 currentStatusActive: 'Active',
};
export const SCRIPT = {
 update_coverage_preview: 'update-coverage-preview',
 update_paid_invoice : 'update-paid-invoice',
 update_deleted_claims: 'update-deleted-claims',
 update_claims_number: 'update-claims-number',
 update_claims_coverage_limits: 'update-claims-coverage-limits',
 update_uw_limits: 'update-uw-limits',
 update_parent_agency_kraft_lake: 'update-parent-agency-kraft-lake',
 insert_underwriter: 'insert-underwriter'
}